// @flow

export function scaleBetween(scale: number, lo: number, hi: number) {
  return scale * (hi - lo) + lo;
}

export function percentageBetween(input: number, lo: number, hi: number) {
  return (input - lo) / (hi - lo);
}
